// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseScheduledPage_root__0iOK3"};